module.exports = __webpack_public_path__ + "static/media/tiktok.118e9b06.svg";